(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-container-navigation.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-container-navigation.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useMemo,
  useReducer,
  useContext
} = React;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  SELECT_INDEX,
  CENTER_INDEX,
  GO_TO_NEXT,
  GO_TO_PREVIOUS,
  GO_TO_SELECTED
} = svs.components.tipsen.drawSelectorComponents.constants.dispatchTypes;

const navReducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  const {
    indexOfCentered,
    indexOfSelected
  } = state;
  switch (type) {
    case SELECT_INDEX:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          indexOfCentered: payload.index,
          indexOfSelected: payload.index
        });
      }
    case GO_TO_PREVIOUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          indexOfCentered: indexOfCentered - payload.stepSize
        });
      }
    case GO_TO_NEXT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          indexOfCentered: indexOfCentered + payload.stepSize
        });
      }
    case GO_TO_SELECTED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          indexOfCentered: indexOfSelected
        });
      }
    case CENTER_INDEX:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          indexOfCentered: payload.index
        });
      }
    default:
      return state;
  }
};

const navReducerInitState = {
  indexOfCentered: 0,
  indexOfSelected: 0
};

const createSetCenterIndexAction = index => ({
  type: CENTER_INDEX,
  payload: {
    index
  }
});
const createSetSelectedIndexAction = index => ({
  type: SELECT_INDEX,
  payload: {
    index
  }
});
const createGoToPreviousAction = stepSize => ({
  type: GO_TO_PREVIOUS,
  payload: {
    stepSize
  }
});
const createGoToNextAction = stepSize => ({
  type: GO_TO_NEXT,
  payload: {
    stepSize
  }
});
const createGoToSelected = () => ({
  type: GO_TO_SELECTED
});

const useContainerNavigation = draws => {
  const {
    drawNumber
  } = useContext(DrawContext);
  const [state, dispatch] = useReducer(navReducer, navReducerInitState);
  const {
    indexOfCentered,
    indexOfSelected
  } = state;

  useEffect(() => {
    if (draws) {
      for (let index = 0; index < draws.length; index++) {
        const currentDrawNumber = Number(draws[index].drawNumber);
        if (currentDrawNumber === Number(drawNumber)) {
          dispatch(createSetSelectedIndexAction(index));
          break;
        }
      }
    }
  }, [draws, drawNumber]);
  return useMemo(() => {
    const lastIndex = draws && draws.length > 0 ? draws.length - 1 : 0;
    const stepsToLast = lastIndex - indexOfCentered;
    return {
      indexOfSelected,
      indexOfCentered,
      setCenteredIndex: index => {
        dispatch(createSetCenterIndexAction(index));
      },
      setSelectedIndex: index => {
        dispatch(createSetSelectedIndexAction(index));
      },
      goToPrevious: function (infinity) {
        let stepSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        if (indexOfCentered !== 0) {
          dispatch(createGoToPreviousAction(stepSize > indexOfCentered ? indexOfCentered : stepSize));
        } else if (infinity) {
          dispatch(createSetCenterIndexAction(lastIndex));
        }
      },
      goToNext: function (infinity) {
        let stepSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        if (indexOfCentered !== lastIndex) {
          dispatch(createGoToNextAction(stepSize > stepsToLast ? stepsToLast : stepSize));
        } else if (infinity) {
          dispatch(createSetCenterIndexAction(0));
        }
      },
      goToSelected: () => {
        dispatch(createGoToSelected());
      }
    };
  }, [indexOfCentered, indexOfSelected, draws]);
};
setGlobal('svs.components.tipsen.drawSelectorComponents.hooks.useContainerNavigation', useContainerNavigation);

 })(window);